module.exports = __webpack_public_path__ + "static/img/ent-87.c41e153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-87.jpg
// module id = ZCSm
// module chunks = 52